import { lang } from '@/constant'

export const locales = Object.freeze({
  DEFAULT_LOCALE: lang.ENGLISH,
  FALLBACK_LOCALE: lang.ENGLISH,
})
